module.exports = __webpack_public_path__ + "static/media/CartMt.41dbef50.svg";